import { inject, Injectable } from "@angular/core";

import { IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";

import { WidgetSourceService } from "@main/reporting.v3/api/widget-source.service";

import { WidgetInfo, WidgetResolver } from "../models";


@Injectable()
export class WidgetResolverService implements WidgetResolver {

    private widgetSourceService: WidgetSourceService = inject(WidgetSourceService);

    public getWidgetInfo(widgetCode: string): Promise<WidgetInfo> {
        const settings: IHttpResponseHandlerSettings = { showErrorMessage: false };

        return this.widgetSourceService.getWidgetSourcePreload(widgetCode, settings);
    }
}
